export const FETCH_CONFIGURATIONS_REQUEST = 'FETCH_CONFIGURATIONS_REQUEST';
export const FETCH_CONFIGURATIONS_SUCCESS = 'FETCH_CONFIGURATIONS_SUCCESS';
export const FETCH_CONFIGURATIONS_FAILURE = 'FETCH_CONFIGURATIONS_FAILURE';

export const FETCH_CONFIGURATION_REQUEST = 'FETCH_CONFIGURATION_REQUEST';
export const FETCH_CONFIGURATION_SUCCESS = 'FETCH_CONFIGURATION_SUCCESS';
export const FETCH_CONFIGURATION_FAILURE = 'FETCH_CONFIGURATION_FAILURE';

export const UPDATE_CONFIGURATIONS_REQUEST = 'UPDATE_CONFIGURATIONS_REQUEST';
export const UPDATE_CONFIGURATIONS_SUCCESS = 'UPDATE_CONFIGURATIONS_SUCCESS';
export const UPDATE_CONFIGURATIONS_FAILURE = 'UPDATE_CONFIGURATIONS_FAILURE';

export const DELETE_CONFIGURATIONS_REQUEST = 'DELETE_CONFIGURATIONS_REQUEST';
export const DELETE_CONFIGURATIONS_SUCCESS = 'DELETE_CONFIGURATIONS_SUCCESS';
export const DELETE_CONFIGURATIONS_FAILURE = 'DELETE_CONFIGURATIONS_FAILURE';

export const DUPLICATE_CONFIGURATIONS_REQUEST = 'DUPLICATE_CONFIGURATIONS_REQUEST';
export const DUPLICATE_CONFIGURATIONS_SUCCESS = 'DUPLICATE_CONFIGURATIONS_SUCCESS';
export const DUPLICATE_CONFIGURATIONS_FAILURE = 'DUPLICATE_CONFIGURATIONS_FAILURE';

export const OPEN_EDIT_PAGE_CONFIGURATION = 'OPEN_EDIT_PAGE_CONFIGURATION';
export const OPEN_EDIT_PAGE_CONFIGURATION_SUCCESS = 'OPEN_EDIT_PAGE_CONFIGURATION_SUCCESS';


export const CHECK_CONFIGURATION_REQUEST = 'CHECK_CONFIGURATION_REQUEST';
export const CHECK_CONFIGURATION_SUCCESS = 'CHECK_CONFIGURATION_SUCCESS';
export const CHECK_CONFIGURATION_FAILURE = 'CHECK_CONFIGURATION_FAILURE';

export const CHECK_CONFIGURATIONS_EXPIRED_REQUEST = 'CHECK_CONFIGURATIONS_EXPIRED_REQUEST';
export const CHECK_CONFIGURATIONS_EXPIRED_SUCCESS = 'CHECK_CONFIGURATIONS_EXPIRED_SUCCESS';
export const CHECK_CONFIGURATIONS_EXPIRED_FAILURE = 'CHECK_CONFIGURATIONS_EXPIRED_FAILURE';

export const VERIFY_CONFIGURATION_REQUEST = 'VERIFY_CONFIGURATIONS_REQUEST';
export const VERIFY_CONFIGURATION_SUCCESS = 'VERIFY_CONFIGURATIONS_SUCCESS';
export const VERIFY_CONFIGURATION_FAILURE = 'VERIFY_CONFIGURATIONS_FAILURE';
export const CLEAR_VERIFY_CONFIGURATION_SUCCESS = 'CLEAR_VERIFY_CONFIGURATION_SUCCESS';
export const CLEAR_VERIFY_CONFIGURATION_ERRORS = 'CLEAR_VERIFY_CONFIGURATION_ERRORS';

export const CLEAR_CONFIGURATION_ERRORS = 'CLEAR_CONFIGURATION_ERRORS';
export const CLEAR_CONFIGURATION_SUCCESS = 'CLEAR_CONFIGURATION_SUCCESS';